var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3501 6.00001C5.3501 3.43188 7.43197 1.35001 10.0001 1.35001C12.5682 1.35001 14.6501 3.43188 14.6501 6.00001V7.40771C16.3558 7.71431 17.6501 9.20601 17.6501 11V15C17.6501 17.0158 16.0159 18.65 14.0001 18.65H6.0001C3.98426 18.65 2.3501 17.0158 2.3501 15V11C2.3501 9.20601 3.64437 7.71431 5.3501 7.40771V6.00001ZM13.3501 6.00001V7.35001H6.6501V6.00001C6.6501 4.14985 8.14994 2.65001 10.0001 2.65001C11.8503 2.65001 13.3501 4.14985 13.3501 6.00001ZM3.6501 11C3.6501 9.70214 4.70223 8.65001 6.0001 8.65001H14.0001C15.298 8.65001 16.3501 9.70214 16.3501 11V15C16.3501 16.2979 15.298 17.35 14.0001 17.35H6.0001C4.70223 17.35 3.6501 16.2979 3.6501 15V11ZM10.6501 12C10.6501 11.641 10.3591 11.35 10.0001 11.35C9.64111 11.35 9.3501 11.641 9.3501 12V14C9.3501 14.359 9.64111 14.65 10.0001 14.65C10.3591 14.65 10.6501 14.359 10.6501 14V12Z",
    fill: "#151F29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7f12464e1b6640b31a67f1b12f1b5489.svg";
export { ForwardRef as ReactComponent };